module.exports = __webpack_public_path__ + "img/3.ba7e7d36.svg";